var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 85,
    viewBox: "0 0 103 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.4662L14.5093 42.5751L18.7169 47.2502L30.1281 59.9178L31.7045 61.6616L34.7099 65L38.1785 61.1475L39.2861 59.9178L65.526 30.7909V52.0953L72 44.9064V13.4356L65.526 20.6224L34.7099 54.8315L31.7045 51.4951L23.2987 42.1639L19.0873 37.4888L9.1524 26.4662L22.5408 11.6038L26.5178 7.18888H46.3858L52.8616 0H23.8393L17.3654 7.18888L13.3865 11.6038L4.5762 21.3862L0 26.4662Z",
    fill: "#050A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2556 12.587L93.8573 26.7498L71.2279 52.1804L51.1706 74.7225L48.1494 71.3271L42.5581 65.0474L37.9877 70.184L43.5809 76.4616L46.602 79.8591L51.1706 85L64.7648 69.7217L71.2279 62.4579L103 26.7498L98.4258 21.6153L95.4028 18.2178L89.636 11.7281L85.8242 7.45253L85.6638 7.2659L79.1988 0H60.5284L54.0634 7.2659L50.0912 11.7281L37.4631 25.9206V11.7281H31V43.4681L59.2395 11.7281L63.2118 7.2659H76.5248L80.4971 11.7281L81.2556 12.587Z",
    fill: "#050A24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondIcon);
export default __webpack_public_path__ + "static/media/diamond-icon.4304cbfa391203da5808e37607e78e55.svg";
export { ForwardRef as ReactComponent };